import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=aa2954ba&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=aa2954ba&lang=sass&scoped=true&"
import style1 from "./Tag.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2954ba",
  null
  
)

export default component.exports